import React from 'react';
import {NavLink} from 'react-router-dom';
import { useTranslation, Trans } from 'react-i18next';
import { useGetApplicationsQuery } from '../../services/api';
import { styled } from '@mui/material/styles';
import '../../translations/i18n';
import { useLayout } from '../../hooks/layout';
import Layout from '../../shared/Layout';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from "swiper";
import { Grid, Typography, Box, Link, Card, Paper, Container, Button, Stack, Slide } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import Img from '../../shared/Img';
import Media from '../../shared/Media';
import businessImg from '../../assets/icons/business.svg';
import innovationImg from '../../assets/icons/innovation.svg';
import creativityImg from '../../assets/icons/creativity.svg';
import inclusivityImg from '../../assets/icons/inclusivity.svg';
import authenticityImg from '../../assets/icons/authenticity.svg';
import meritocracyImg from '../../assets/icons/meritocracy.svg';
import info1Img from '../../assets/images/info/info1.jpg';
import info2Img from '../../assets/images/info/info2.jpg';
import info3Img from '../../assets/images/info/info3.jpg';
import info4Img from '../../assets/images/info/info4.jpg';
import info5Img from '../../assets/images/info/info5.jpg';
import info6Img from '../../assets/images/info/info6.jpg';
import info7Img from '../../assets/images/info/info7.jpg';
import info8Img from '../../assets/images/info/info8.jpg';
import 'swiper/css';
import "swiper/css/pagination";

const TextHighlight = styled('span')(({ theme }) => ({
  color: '#fff',
  position: 'relative',
  zIndex: 1,
  '&:after': {
  	content: '""',
    backgroundColor: theme.palette.primary.main,
    position: 'absolute',
    top: 0,
    right: 0,
    width: '100%',
    height: '100%',
    zIndex: -1,
    transform: 'rotate(358deg)'
  },
}));

const ImageText = (props) => {

	const { img, children } = props;
	const { isMobile } = useLayout();
	const [checked, setChecked] = React.useState(false);
 	const containerRef = React.useRef(null);

	return(
		<Box
			ref={containerRef}
			sx={{
				position: 'relative',
				borderRadius: 5,
				overflow: 'hidden',
				paddingTop: '56.25%;',
				background: 'url('+img+') center center/cover no-repeat',
				width: '100%'
			}}
			onMouseEnter={() => { setChecked(true); }}
			onMouseLeave={() => { setChecked(false) }}
		>
			<Slide direction="up" in={checked} container={containerRef.current}>
	          <Box
	          	sx={{
	          		background: 'rgba(0,0,0,0.7)',
	          		position: 'absolute',
	          		top: 0,
	          		left: 0,
	          		width: '100%',
	          		height: '100%',
	          		display: 'flex',
	          		justifyContent: 'center',
	          		alignItems: 'center',
	          	}}
	          >
	          	<Typography
	          		align="center"
	          		component="div"
	          		variant={isMobile ? 'caption' : 'body1'}
	          		color="white.main"
	          		sx={{px: 4}}
	          	>
	          		{children}
	          	</Typography>
	          </Box>
	        </Slide>
        </Box>
	);
}

const Index = () => {

	const { t } = useTranslation();

	return(
		<Layout 
			seo={{}}
		>
			<Grid 
				container 
				justifyContent="center" 
				sx={{
					pt: {
						xs: 12,
						md: 17
					}
				}}
			>
				<Grid 
					item 
					xs={12} 
				>
					<Typography
						color="primary"
					>
						<b>{t("whoweare_topContent_overtitle")}</b>
					</Typography>
					<Grid 
						container 
						spacing={6}
					>
						<Grid 
							item 
							xs={12} 
							md={6}
						>
							<Typography
								variant="h1"
								color="text.primary"
								gutterBottom
							>
								<b><Trans i18nKey="whoweare_topContent_title">Quindi siete bravi a cucinare?<br/>Sì, <TextHighlight>ma non solo!</TextHighlight></Trans></b>
							</Typography>
							<Box
								sx={{
									display: {
										md: 'none'
									},
									my: 3
								}}
							>
								<Swiper
									loop	
									spaceBetween={30}
									slidesPerView={1}
									speed={700}
									className="fullPagination"
									pagination={{
								    clickable: true,
								    renderBullet: function (index, className) {
								      return '<span class="' + className + '"></span>';
								    }
									}}
									modules={[Pagination, Autoplay]}
									autoplay={{
										delay: 2000,
										disableOnInteraction: true
									}}
							    >
										<SwiperSlide>
											<Img src={info6Img} sx={{width: '100%', borderRadius: 10}} />
										</SwiperSlide>
										<SwiperSlide>
											<Img src={info7Img} sx={{width: '100%', borderRadius: 10}} />
										</SwiperSlide>
									</Swiper>
							</Box>
							<Typography
								variant="h3"
								color="text.primary"
								sx={{fontWeight: 500, my: 3}}
							>
								<Trans i18nKey="whoweare_topContent_body">
									Chef in Camicia è il media che si propone di diffondere il mondo del food a 360°. Siamo <strong>giovani che si rivolgono ai giovani.</strong>
								</Trans>
							</Typography>	
							<Typography
								color="text.primary"
								sx={{fontWeight: 500, mb: 3}}
							>
								<Trans i18nKey="whoweare_topContent_body2">
									Leggerezza, divertimento e passione<br/> sono le chiavi di lettura del nostro lavoro.
								</Trans>
							</Typography>
						</Grid>
						<Grid 
							item 
							xs={12} 
							md={6}
							sx={{
								display: {
									xs: 'none',
									md: 'block'
								}
							}}
						>
							<Swiper
								loop	
								spaceBetween={30}
								slidesPerView={1}
								speed={700}
								className="fullPagination"
								pagination={{
							    clickable: true,
							    renderBullet: function (index, className) {
							      return '<span class="' + className + '"></span>';
							    }
								}}
								modules={[Pagination, Autoplay]}
								autoplay={{
									delay: 2000,
									disableOnInteraction: true
								}}
						  >
						  	{
						  		[info6Img, info7Img].map((img) => (
						  			<SwiperSlide key={img}>
						  				<Box>
												<Img src={img} sx={{width: '100%', borderRadius: 10}} />
											</Box>
										</SwiperSlide>
						  		))
						  	}
							</Swiper>
						</Grid>
					</Grid>
					<Box
						sx={{
							ml: {
								xs: -2,
								sm: -4,
								lg: -35
							},
							mr: {
								xs: -2,
								sm: -4,
								lg: -35
							},
							background: '#fff',
							mt: 3,
							py: 3
						}}
					>
						<Container>
							<Grid 
								container 
								sx={{py: 3}}
								spacing={6}
							>
								<Grid 
									item 
									xs={12}
									md={6} 
								>
									<Img src={info8Img} sx={{width: '100%', borderRadius: 10}} />
									<Stack
										direction="row"
										justifyContent="center"
										sx={{
											display: {
												xs: 'none',
												md: 'flex'
											},
											mt: 3
										}}
									>
										<Box px={3}>
											<Typography
												variant="h1"
												color="text.primary"
											>
												<b>{t("whoweare_infoContent_followersNumber")}</b>
											</Typography>
											<Typography
												variant="h3"
												color="text.primary"
											>
												{t("whoweare_infoContent_followersLabel")}
											</Typography>
										</Box>
										<Box px={3}>
											<Typography
												variant="h1"
												color="text.primary"
											>
												<b>{t("whoweare_infoContent_employeesNumber")}</b>
											</Typography>
											<Typography
												variant="h3"
												color="text.primary"
											>
												{t("whoweare_infoContent_employeesLabel")}
											</Typography>
										</Box>
									</Stack>
								</Grid>
								<Grid 
									item 
									xs={12}
									md={6} 
								>
									<Typography
										color="text.primary"
									>
										<Trans i18nKey="whoweare_infoContent_body">
											Chef in Camicia è stata fondata nel 2015 da tre amici - Lello, Andrea e Nicolò - accomunati dalla stessa passione: <strong>l’amore per il cibo.</strong><br/><br/>L’idea iniziale era sviluppare una azienda nel settore eventi ma, cogliendo e anticipando la potenzialità del settore digital, nell’Aprile del 2016 i tre chef hanno lanciato la loro prima video ricetta su Facebook e Instagram.<br/><br/> <strong>E da lì il successo:</strong><br/> In pochi anni Chef è cresciuta velocemente e ad oggi conta uno staff di <strong>40 persone</strong> e una community online di oltre <strong>10 milioni</strong>.
										</Trans>
									</Typography>
									<Stack
										direction="row"
										justifyContent="center"
										sx={{
											display: {
												md: 'none'
											},
											mt: 3
										}}
									>
										<Box px={3}>
											<Typography
												variant="h1"
												color="text.primary"
											>
												<b>{t("whoweare_infoContent_followersNumber")}</b>
											</Typography>
											<Typography
												variant="h3"
												color="text.primary"
											>
												{t("whoweare_infoContent_followersLabel")}
											</Typography>
										</Box>
										<Box px={3}>
											<Typography
												variant="h1"
												color="text.primary"
											>
												<b>{t("whoweare_infoContent_employeesNumber")}</b>
											</Typography>
											<Typography
												variant="h3"
												color="text.primary"
											>
												{t("whoweare_infoContent_employeesLabel")}
											</Typography>
										</Box>
									</Stack>
								</Grid>
							</Grid>
						</Container>
					</Box>
					<Typography
						align="center"
						variant="h2"
						color="text.primary"
						sx={{
							my: 6
						}}
					>
						<b>{t("whoweare_bottomContent_title")}</b>
					</Typography>
					<Grid 
						container
						spacing={7}
					>
						<Grid 
							item
							xs={12}
							md={4} 
							sx={{textAlign: 'center'}}
						>
							<Img 
								src={businessImg} 
								sx={{ 
									width: '60%'
								}} 
							/>
							<Typography
								variant="h3"
								color="text.primary"
								sx={{mb: 5}}
							>
								<b>{t("whoweare_bottomContent_highlightTitle1")}</b>
							</Typography>
							<Typography
								align="center"
								color="text.primary"
							>
								{t("whoweare_bottomContent_highlightBody1")}
							</Typography>
						</Grid>
						<Grid 
							item
							xs={12}
							md={4} 
							sx={{textAlign: 'center'}}
						>
							<Img 
								src={innovationImg} 
								sx={{ 
									width: '60%' 
								}} 
							/>
							<Typography
								variant="h4"
								color="text.primary"
								sx={{mb: 5}}
							>
								<b>{t("whoweare_bottomContent_highlightTitle2")}</b>
							</Typography>
							<Typography
								align="center"
								color="text.primary"
							>
								{t("whoweare_bottomContent_highlightBody2")}
							</Typography>
						</Grid>
						<Grid 
							item
							xs={12}
							md={4} 
							sx={{textAlign: 'center'}}
						>
							<Img 
								src={creativityImg} 
								sx={{ 
									width: '60%' 
								}} 
							/>
							<Typography
								variant="h4"
								color="text.primary"
								sx={{mb: 5}}
							>
								<b>{t("whoweare_bottomContent_highlightTitle3")}</b>
							</Typography>
							<Typography
								align="center"
								color="text.primary"
							>
								{t("whoweare_bottomContent_highlightBody3")}
							</Typography>
						</Grid>
						<Grid 
							item
							xs={12}
							md={4} 
							sx={{textAlign: 'center'}}
						>
							<Img 
								src={inclusivityImg} 
								sx={{ 
									width: '60%' 
								}} 
							/>
							<Typography
								variant="h4"
								color="text.primary"
								sx={{mb: 5}}
							>
								<b>{t("whoweare_bottomContent_highlightTitle4")}</b>
							</Typography>
							<Typography
								align="center"
								color="text.primary"
							>
								{t("whoweare_bottomContent_highlightBody4")}
							</Typography>
						</Grid>
						<Grid 
							item
							xs={12}
							md={4} 
							sx={{textAlign: 'center'}}
						>
							<Img 
								src={authenticityImg} 
								sx={{ 
									width: '60%' 
								}} 
							/>
							<Typography
								variant="h4"
								color="text.primary"
								sx={{mb: 5}}
							>
								<b>{t("whoweare_bottomContent_highlightTitle5")}</b>
							</Typography>
							<Typography
								align="center"
								color="text.primary"
							>
								{t("whoweare_bottomContent_highlightBody5")}
							</Typography>
						</Grid>
						<Grid 
							item
							xs={12}
							md={4} 
							sx={{textAlign: 'center'}}
						>
							<Img 
								src={meritocracyImg} 
								sx={{ 
									width: '60%' 
								}} 
							/>
							<Typography
								variant="h4"
								color="text.primary"
								sx={{mb: 5}}
							>
								<b>{t("whoweare_bottomContent_highlightTitle6")}</b>
							</Typography>
							<Typography
								align="center"
								color="text.primary"
							>
								{t("whoweare_bottomContent_highlightBody6")}
							</Typography>
						</Grid>
					</Grid>
					<Typography
						align="center"
						variant="h2"
						color="text.primary"
						my={8}
					>
						<b>{t("whoweare_teamContent_title")}</b>
					</Typography>
					<Grid 
						container 
						spacing={4}
						justifyContent="center"
					>
						<Grid 
							item 
							xs={12}
							md={6} 
							sx={{pb: 6}}
						>
							<ImageText img={info1Img}>
								{t("whoweare_teamContent_highlightBody1")}
							</ImageText>
							<Typography
								align="center"
								variant="h4"
								color="text.primary"
								sx={{mt: 3}}
							>
								<b>{t("whoweare_teamContent_highlightTitle1")}</b>
							</Typography>
						</Grid>
						<Grid 
							item 
							xs={12}
							md={6} 
							sx={{pb: 6}}
						>
							<ImageText img={info2Img}>
								{t("whoweare_teamContent_highlightBody2")}
							</ImageText>
							<Typography
								align="center"
								variant="h4"
								color="text.primary"
								sx={{mt: 3}}
							>
								<b>{t("whoweare_teamContent_highlightTitle2")}</b>
							</Typography>
						</Grid>
						<Grid 
							item 
							xs={12}
							md={6} 
							sx={{pb: 6}}
						>
							<ImageText img={info3Img}>
								{t("whoweare_teamContent_highlightBody3")}
							</ImageText>
							<Typography
								align="center"
								variant="h4"
								color="text.primary"
								sx={{mt: 3}}
							>
								<b>{t("whoweare_teamContent_highlightTitle3")}</b>
							</Typography>
						</Grid>
						<Grid 
							item 
							xs={12}
							md={6} 
							sx={{pb: 6}}
						>
							<ImageText img={info4Img}>
								{t("whoweare_teamContent_highlightBody4")}
							</ImageText>
							<Typography
								align="center"
								variant="h4"
								color="text.primary"
								sx={{mt: 3}}
							>
								<b>{t("whoweare_teamContent_highlightTitle4")}</b>
							</Typography>
						</Grid>
						<Grid 
							item 
							xs={12}
							md={6} 
							sx={{pb: 6}}
						>
							<ImageText img={info5Img}>
								{t("whoweare_teamContent_highlightBody5")}
							</ImageText>
							<Typography
								align="center"
								variant="h4"
								color="text.primary"
								sx={{mt: 3}}
							>
								<b>{t("whoweare_teamContent_highlightTitle5")}</b>
							</Typography>
						</Grid>
					</Grid>
					<Box
						sx={{
							ml: {
								xs: -2,
								sm: -4,
								lg: -35
							},
							mr: {
								xs: -2,
								sm: -4,
								lg: -35
							},
							background: '#fff',
							mt: 3,
							py: 6
						}}
					>
						<Container>
							<Grid 
								container 
								justifyContent="center"
							>
								<Grid 
									item 
									xs={12} 
									sx={{textAlign:'center'}}
								>
									<Typography
										variant="h3"
										color="text.primary"
										sx={{mb:6}}
									>
										<b><Trans i18nKey="whoweare_lastContent_title">Cerchiamo e valorizziamo talenti,<br/> cosa aspetti?</Trans></b>
									</Typography>
									<Button
										variant="contained"
										color="primary"
										component={NavLink}
										to="/lavora-con-noi"
									>
										{t("whoweare_lastContent_buttonLabel")}
									</Button>
								</Grid>
							</Grid>
						</Container>
					</Box>
				</Grid>
			</Grid>
		</Layout>
	);
}

export default Index;